<section id="content" *ngIf="this.alang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2>Scheduled course view</h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.CUSTOMERS_VIEW + '/' + this.id">Scheduled course view</a>
          </li>
          <!-- <li>
            <span *ngIf="single_data">{{ single_data.code }} / {{ single_data.bussines_name }}</span>
          </li> -->

        </ul>

        <div style="float: right;">
          <div class="social-icons">
            <!-- <a class="plus-vdead" (click)="viewServicing()"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-list"></i>
            </a> -->

            <a class="plus-edit" [routerLink]="['/'+AppFrontRoutes.EDIT_CUSTOMER+'/'+this.id]"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"
              [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
              <i class="fa fa-edit"></i>
            </a>
          </div>
        </div>

      </div>
    </div>
    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body" [ngSwitch]="pageView">
              <div role="tabpanel" *ngSwitchCase="'list'">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" [ngClass]="{ 'active':generalTab==='activeTab'}"><a href="#generalTab"
                      aria-controls="feedTab" role="tab" data-toggle="tab">General Data</a></li>

                  <li role="presentation" [ngClass]="{ 'active':operatingTab==='activeTab'}"><a href="#operating"
                      aria-controls="operating" role="tab" data-toggle="tab">Attendies</a></li>

                  <li role="presentation" [ngClass]="{ 'active':operatingTab==='activeTab'}"><a href="#final_document"
                      aria-controls="final_document" role="tab" data-toggle="tab">Final Document</a></li>


                  <li role="presentation" [ngClass]="{ 'active':generalTab==='activeTab'}"><a href="#final_evaluation"
                      aria-controls="final_evaluation" role="tab" data-toggle="tab">Final Evaluation</a></li>

                      <div style="float: right;">
                        <div class="social-icons">
                          <a class="plus-add toottip" (click)="add()" [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <i class="fa fa-envelope"></i>
                          </a>
                        </div>
                      </div>


                </ul>

    

                <!-- <div class="social-icons">

                  <a class="plus-add" (click)="addServicing()">
                  <i class="fa fa-plus"></i>
                </a>
                </div> -->

                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">

                    <div class="row p-10">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="table-responsive">
                            <table class="table table-striped table-hover table-bordered">
                              <tbody>
                                <tr>
                                  <td width="20%">Course Code</td>
                                  <td>{{ sc_single_data.sc_couse_code }}</td>
                                </tr>
                                <tr>
                                  <td>Catalogue Code</td>
                                  <td>{{ sc_single_data.cat_code }}</td>
                                </tr>
                                <tr>
                                  <td>Course Name</td>
                                  <td>{{ sc_single_data.sc_course_name }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Course Category</td>
                                  <td>{{ sc_single_data.sc_course_catgy }}</td>
                                </tr>
                                <tr>
                                  <td>Duration (hours)</td>
                                  <td>{{ sc_single_data.sc_duration }}</td>
                                </tr>

                                <tr>
                                  <td>Place of Performance</td>
                                  <td>{{ sc_single_data.place_perf }}</td>
                                </tr>

                                <tr>
                                  <td>Actuator body</td>
                                  <td>{{ sc_single_data.act_body }}</td>
                                </tr>

                                <tr>
                                  <td>Teacher</td>
                                  <td> <a
                                      href="https://www.kaizencloud.eu/kaizencloud_new/index.php/academy/qualified_teacher_view/{{ sc_single_data.sc_teacher_name }}">{{
                                      sc_single_data.teacher }}</a><br>
                                  </td>

                                </tr>
                              </tbody>
                            </table>
                          </div>


                          <div class="col-md-12 text-center" style="margin-top: 20px;">
                            <div class="col-md-6">
                              <div class="numbers_cls">
                                <p>No. of Customers</p>
                                <span>{{ sc_single_data.customers_count }}</span>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="numbers_cls">
                                <p>No. of Attendees</p>
                                <span style="background: #efa740;">{{ sc_single_data.employees_count }}</span>
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                            <a class="btn btn-purple btn-block generate_test" data-type="didactic_test"
                              href="javascript:void(0);" (click)="add('didactic_test')"><i class="fa fa-plus pull-left"
                                style="margin:5px 6px"></i>Generate Didactic Register</a>
                          </div>
                          <div class="form-group">
                            <a class="btn btn-purple btn-block generate_test" data-type="general_test"
                              href="javascript:void(0);" (click)="add('general_test')"><i class="fa fa-plus pull-left"
                                style="margin:5px 6px"></i>Generate Tests</a>
                          </div>
                          <div class="form-group">
                            <a class="btn btn-purple btn-block generate_test" data-type="satisfaction_test"
                              href="javascript:void(0);" (click)="add('satisfaction_test')"><i
                                class="fa fa-plus pull-left" style="margin:5px 6px"></i>Generate Satisfaction Test</a>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                            <div class="show-value">
                              <a href="https://www.kaizencloud.eu/kaizencloud_new/index.php/academy/schedule_course_generate_pdf/didactic_test/53"
                                target="_blank">
                                2019_01_FOR_Didactic Register
                              </a>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="show-value">
                              <a href="https://www.kaizencloud.eu/kaizencloud_new/index.php/academy/schedule_course_generate_pdf/general_test/53"
                                target="_blank">
                                2019_01_FOR_Test
                              </a>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="show-value">
                              <a href="https://www.kaizencloud.eu/kaizencloud_new/index.php/academy/schedule_course_generate_pdf/satisfaction_test/53"
                                target="_blank">
                                2019_01_FOR_Satisfaction Test
                              </a>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6" id="add_more">
                          <div class="row" style="padding:50px">

                            <form class="certification_form">
                              <div class="form-group" style="margin-bottom:15px;">
                                <label class="col-sm-3 control-label" for="form-field-3">Upload Didactic Register
                                  Completed</label>

                                <div class="content">
                                  <div class="col-sm-6">
                                    <input type="file" class="filestyle" data-buttonText="Choose file"
                                      (change)="selectAttachment1($event,i)" appFileDesign>
                                  </div>

                                  <div class="col-sm-3 form_deletes">
                                    <a href="javascript:void(0);"
                                      class=" common-newicons icon-colors2 certification_save"
                                      (click)="certification_save()">
                                      <span class="glyphicon glyphicon-floppy-disk"></span>
                                    </a>

                                  </div>

                                </div>
                              </div>
                            </form>

                            <form class="certification_form" style="margin-top: 25%;">
                              <div class="form-group" style="margin-bottom:15px;">
                                <label class="col-sm-3 control-label" for="form-field-3">Upload Tests Completed</label>

                                <div class="content">
                                  <div class="col-sm-6">
                                    <input type="file" class="filestyle" data-buttonText="Choose file"
                                      (change)="selectAttachment1($event,i)" appFileDesign>
                                  </div>

                                  <div class="col-sm-3 form_deletes">
                                    <a href="javascript:void(0);"
                                      class=" common-newicons icon-colors2 certification_save">
                                      <span class="glyphicon glyphicon-floppy-disk"></span>
                                    </a>

                                  </div>

                                </div>
                              </div>
                            </form>

                            <form class="certification_form" style="margin-top: 40%;">
                              <div class="form-group" style="margin-bottom:15px;">
                                <label class="col-sm-3 control-label" for="form-field-3">Upload Satisfaction Tests
                                  Completed</label>

                                <div class="content">
                                  <div class="col-sm-6">
                                    <input type="file" class="filestyle" data-buttonText="Choose file"
                                      (change)="selectAttachment1($event,i)" appFileDesign>
                                  </div>

                                  <div class="col-sm-3 form_deletes">
                                    <a href="javascript:void(0);"
                                      class=" common-newicons icon-colors2 certification_save">
                                      <span class="glyphicon glyphicon-floppy-disk"></span>
                                    </a>

                                  </div>

                                </div>
                              </div>
                            </form>

                          </div>
                        </div>



                      </div>
                      <div class="row" style="margin-top: 40px;">
                        <div class="col-md-6">

                          <div class="panel panel-default">
                            <div class="panel-heading">
                              Modules </div>
                            <div class="panel-body">
                              <div class="table-responsive">
                                <table class="table table-striped" id="example5">
                                  <thead>
                                    <tr>
                                      <th> Module Number</th>
                                      <th>Title</th>
                                      <th>Duration (hours)</th>
                                      <th>Teacher</th>
                                      <th>Start Date</th>
                                      <th>End Date</th>
                                      <th>Execution Dates</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let get_module of set_scheduled let i = index"
                                      id="{{get_module.scheduled_moduleId }}">
                                      <td>{{ get_module.scm_num_module }}</td>
                                      <td>{{ get_module.scm_arguments }}</td>
                                      <td>{{ get_module.scm_duration }}</td>
                                      <td> <a
                                          href="https://www.kaizencloud.eu/kaizencloud_new/index.php/academy/qualified_teacher_view/{{ get_module.scm_teacher }}">{{
                                          get_module.scm_teacher }}</a><br>
                                      </td>
                                      <td>{{ get_module.scm_start_date }}</td>
                                      <td>{{ get_module.scm_end_date }} </td>
                                      <td>{{ get_module.exec_dates }} </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                        </div>


                        <div class="col-md-6">

                          <div class="panel panel-default">
                            <div class="panel-heading">
                              Global Evaluation </div>
                            <div class="panel-body">

                              <div class="row global_cls">

                                <div class="col-md-5">
                                  <div style="display: block;">
                                    <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels"
                                      [chartType]="doughnutChartType" width="256" height="256"
                                      style="display: block; height: 205px; width: 205px;">
                                    </canvas>
                                  </div>
                                </div>

                                <div class="col-md-5">
                                  <div style="display: block;">
                                    <canvas baseChart [datasets]="radarChartData" [options]="radarChartOptions"
                                      [labels]="radarChartLabels" [chartType]="radarChartType" width="600"
                                      height="600"></canvas>
                                  </div>
                                </div>

                                <div class="col-md-2">
                                  <h4>Final Results</h4>
                                  <p style="margin-top: 70px;font-size: 25px;color: red;"><span class="final_result">{{
                                      final_document }}</span>/4.0</p>
                                </div>

                              </div>



                            </div>
                          </div>

                        </div>


                      </div>
                    </div>
                  </div>

                  <div role="tabpanel" class="tab-pane academy-operating" id="operating">

                    <div class="row p-10">
                      <div class="col-sm-1">

                        <div class="social-icons">

                          <a class="plus-export" data-toggle="modal" data-target="#datatableExport1"
                            data-options="splash-2 splash-ef-4">
                            <span class="glyphicon glyphicon-export"></span>
                          </a>


                          <a class="plus-copy" (click)="multiDuplicate()" data-action="show" data-id=""
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-file"></span>
                          </a>

                          <a class="plus-delete" *ngIf="deleteOption" (click)="multiDelete()"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <span class="glyphicon glyphicon-trash"></span>
                          </a>

                        </div>

                      </div>

                      <div class="col-sm-1" >
                        <div class="social-icons">
                          <a class="plus-add" (click)="add_operating(this.id)"
                            [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'">
                            <button class="btn btn-success"><i class="fa fa-plus"></i>Add Customer</button>
                          </a>
                        </div>
                      </div>


                      <div  class="col-sm-9">
                        <input
                        style="float: right;width: 20%;"
                        #search
                        id="search"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-label="Search"
                        aria-describedby="basic-addon1"
                      />                        
                      </div>                         
                    </div>

                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>No.</th>
                            <th>{{ alang.code }}</th>
                            <th>{{ alang.businessName }}</th>
                            <th>{{ alang.address }}</th>
                            <th>{{ alang.zipCode }}</th>
                            <th>{{ alang.city }}</th>
                            <th>{{ alang.province }}</th>
                            <th>{{ alang.taxCode }}</th>
                            <th>{{ alang.fiscalCode }}</th>
                            <th>{{ alang.macroSector }}</th>
                            <th>{{ alang.telephone }}</th>
                            <th>{{ alang.email }}</th>
                            <th>{{ alang.contract }}</th>
                            <th>{{ alang.addAttendees }}</th>
                            <th>{{ alang.action }}</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr #trRef *ngFor="let record of attendies_val let i = index" id="{{record.customer_id }}">
                            <td class="details-control" (click)="expandRow(trRef, record)"></td>
                            <td>{{i+1}}</td>
                            <td></td>
                            <td>{{i+1}}</td>
                            <td>{{ record.code }}</td>
                            <td>{{ record.buss_code }}</td>
                            <td>{{ record.address }}</td>
                            <td>{{ record.zip_code }}</td>
                            <td>{{ record.city }}</td>
                            <td>{{ record.province }}</td>
                            <td>{{ record.tax_code }}</td>
                            <td>{{ record.fiscal_code }}</td>
                            <td>{{ record.macro_sector }}</td>
                            <td>{{ record.phone }}</td>
                            <td>{{ record.email }}</td>
                            <td>{{ record.image }}</td>
                            <td></td>
                            <td>
                              <div class="btn-group dropup">

                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>

                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="delete_action" (click)="delete(record.scheduled_courseId)"><i
                                        class="fa fa-trash"></i>Erase</a></li>
                                  <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a
                                      class="edit_action" (click)="edit(record.scheduled_courseId)"><i
                                        class="fa fa-edit"></i>Modify</a></li>
                                  <li><a [routerLink]="['/'+AppFrontRoutes.DEADLINE_VIEW+'/'+record.scheduled_courseId]"
                                      class="blue_action"><i class="glyphicon glyphicon-eye-open"></i>View</a></li>

                                </ul>
                              </div>
                            </td>
                          </tr>
                        </tbody>


                        <tbody *ngIf="data?.length == 0">
                          <tr>
                            <td colspan="11" class="no-data-available">No data!</td>
                          </tr>
                        </tbody>
                      </table>

                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" id="final_document">


                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover"
                        id="table1">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                                <input type="checkbox"><i></i>
                              </label>
                            </th>
                            <th>S.No.</th>
                            <th>Name</th>
                            <th>Surname</th>
                            <th>Employee Of The Customer</th>
                            <th>Course Outcome</th>
                            <th>Certificate</th>
                            <th>Delivery Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th></th>
                            <td>1</td>
                            <td></td>
                            <td>1</td>
                            <td> employee 1</td>
                            <td> test </td>
                            <td> Test 001 - business </td>
                            <td><select>
                                <option value="">Select</option>
                                <option value="1">Negative</option>
                                <option value="2">Positive</option>
                              </select></td>
                            <td>

                              <a href="javascript:void(0);"
                                class="common-newicons icon-colors4 final_document_certificate_add export_new"
                                style="display:inline-block;" title="Add" (click)="add()">
                                <span class="glyphicon glyphicon-plus"></span>
                              </a>


                              <a href="https://www.kaizencloud.eu/kaizencloud_new/index.php/academy/final_document_certificate_display/372/238"
                                class="common-newicons icon-colors2" style="display:inline-block;" title="View"
                                target="_blank">
                                <span class="glyphicon glyphicon-eye-open"></span>
                              </a>

                              <a href="https://www.kaizencloud.eu/kaizencloud_new/index.php/academy/final_document_certificate_display/372/238/download"
                                class="common-newicons icon-colors1" style="display:inline-block;" title="Download"
                                target="_blank">
                                <span class="glyphicon glyphicon-download-alt"></span>
                              </a>

                              <a href="javascript:void(0);"
                                class="common-newicons icon-colors3 final_document_certificate_click_delete"
                                style="display:inline-block;" title="Delete"
                                data-action="final_document_certificate_pdf_delete" (click)="delete()">
                                <span class="glyphicon glyphicon-trash"></span>
                              </a>
                            </td>
                            <td></td>

                          </tr>
                        </tbody>

                      </table>

                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" id="final_evaluation">


                    <div ng-app="testmyApp" class="form-group" style="overflow: auto;">
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Attendies</th>
                                                        <th>ti è piaciuto il corso?</th>
                                                        <th>è stato bravo il docente?</th>
                                                      <th>Average</th>
                            <th></th>
                          </tr>
                        </thead>
  
                        <tbody>
                          
  
                          
                                                      
                            <tr data-id="238">
                              <td>1</td>
                              <td>Attendee 1</td>
                                                            <td data-id="22">
                                  <input type="text" class="final_evaluation_input" custom_valid="true" value="" disabled="">
                                </td>
                                                            <td data-id="23">
                                  <input type="text" class="final_evaluation_input" custom_valid="true" value="" disabled="">
                                </td>
                                
                              <td class="final_evaluation_average">
                                0                            </td>
  
                              <td>
                                <a href="javascript:void(0);" class="common-newicons icon-colors1 final_evaluation_edit" style="display: inline-block;">
                                  <span class="glyphicon glyphicon-edit"></span>
                                </a>
  
                                <a href="javascript:void(0);" class="common-newicons icon-colors2 final_evaluation_save" style="display: inline-block;">
                                  <span class="glyphicon glyphicon-floppy-disk"></span>
                                </a>
  
                              </td>
  
                            </tr>
  
                            
                          
                        </tbody>
  
                      </table>

                    </div>

                  </div>


                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>